var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-list"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"orange_circle-icon"}),_c('p',[_vm._v(_vm._s(item))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }